import cardValidator from 'card-validator'
import { type ReactElement } from 'react'
import { stripCardFormatting } from '../../../../../../../shared/utils/formattingUtils'
import VisaLogo from './logos/VisaLogo'
import MastercardLogo from './logos/MastercardLogo'
import DiscoverLogo from './logos/DiscoverLogo'
import AmericanExpressLogo from './logos/AmericanExpressLogo'

export const mapping = {
  'american-express': AmericanExpressLogo,
  AMEX: AmericanExpressLogo,
  DISC: DiscoverLogo,
  discover: DiscoverLogo,
  mastercard: MastercardLogo,
  MC: MastercardLogo,
  visa: VisaLogo,
  VISA: VisaLogo
}
export function currentCardBrandFromString (brand: string | null | undefined): ReactElement | null {
  // @ts-expect-error
  const Component = mapping[brand]
  if (!Component) { return null }
  return (
    <div className=" h-1/3 w-1/3">
      <Component />
    </div>
  )
}

export function currentCardBrand (number: string | null | undefined): (() => ReactElement) | null {
  if (!number) { return null }
  const formatted = stripCardFormatting(number).substring(0, 16)
  const numberValidation = cardValidator.number(formatted)
  if (!numberValidation.isPotentiallyValid) { return null }
  const type = numberValidation?.card?.type as string
  // @ts-expect-error
  return mapping[type]
}
